<template>
  <div class="dashboard">
    <component-jumbotrons/>
    <!--<component-slide-carrossel/>-->
      <!--<div>-->
        <!--<v-btn color="primary">Primary</v-btn>-->
        <!--<v-btn color="success">Success</v-btn>-->
        <!--<v-btn color="error">Error</v-btn>-->
        <!--<v-btn color="warning">Warning</v-btn>-->
        <!--<v-btn color="info">Info</v-btn>-->
      <!--</div>-->
  </div>
</template>

<script>

import componentSlideCarrossel from './ComponentSlideCarrossel.vue'
import componentJumbotrons from './ComponentJumbotrons.vue'

export default {
  components: {
    // componentSlideCarrossel: componentSlideCarrossel // Assim Funciona
    // componentSlideCarrossel // Assim Funciona
    'component-slide-carrossel': componentSlideCarrossel,
    'component-jumbotrons': componentJumbotrons
  }
}
</script>
